import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-form-dirty-deactivate-confirm-dialog',
  templateUrl: './form-dirty-deactivate-confirm-dialog.component.html',
  styleUrls: ['./form-dirty-deactivate-confirm-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton],
})
export class FormDirtyDeactivateDialogComponent {
  private dialogRef = inject<MatDialogRef<FormDirtyDeactivateDialogComponent>>(MatDialogRef);
  public data = inject<Model.DialogData>(MAT_DIALOG_DATA);

  private diameter = 50;

  /**
   * This method is used to close the dialog box.
   * @param data is the data sent while closing the dialog box.
   */
  public closeDialog(_data: Model.ConfirmDialogModel): void {
    this.dialogRef.close({ confirmFlag: false });
  }

  /**
   * This method is used to confirm the operation to delete the contact.
   */
  public confirmAction(): void {
    this.dialogRef.close({ confirmFlag: true });
  }
}
